export class HarmonyError extends Error {
    constructor(code, messages) {
        super(messages);
        /**
         * If error is thrown due to an unexpected response, the response (for
         * example `<FAILED_ERROR_TYPE>_WITH_STATUS`), the response status can be
         * stored here.
         */
        this.status = -1;
        /**
         * Sets the unrecoverable function to `true`.
         */
        this.unrecoverable = false;
        /**
         * Object for storing properties of an event that's usefull for debugging.
         */
        this.debug = {};
        this.code = code;
        this.name = 'HarmonyError';
    }
    /**
     * Sets the unrecoverable function to `true`.
     *
     * @param code - The error code.
     * @param message - The error message.
     * @return HarmonyError
     */
    static fatal(code, message) {
        const error = new HarmonyError(code, message);
        error.unrecoverable = true;
        return error;
    }
}
//# sourceMappingURL=harmony_error.js.map